module.exports = __webpack_public_path__ + "static/media/bz.b3d36ab7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bz.svg
// module id = 78
// module chunks = 0